import React from 'react';
import Footer from './footer.jsx';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <React.Fragment>
      <nav style={{ width: '100%', background: 'rgba(10,17,40,0.97)', borderBottom: '1px solid #1e293b22', padding: '12px 0', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100 }}>
        <Link to="/" style={{ color: '#fff', fontWeight: 700, fontSize: '1.2rem', textDecoration: 'none', letterSpacing: '0.01em' }}>IROD Home</Link>
      </nav>
      <div style={{ maxWidth: 700, margin: '40px auto', padding: '32px 16px', background: 'rgba(18,24,38,0.97)', borderRadius: '1.2rem', color: '#e5e7eb', boxShadow: '0 2px 24px 0 rgba(30,40,90,0.13)' }}>
        <h1 style={{ fontSize: '2.2rem', fontWeight: 800, marginBottom: 16 }}>Privacy Policy</h1>
        <p>We value your privacy. This page explains how IROD collects, uses, and protects your information when you contact us or use our services.</p>
        <h2 style={{ marginTop: 24, fontSize: '1.3rem' }}>Information We Collect</h2>
        <ul style={{ marginLeft: 24 }}>
          <li><b>Contact Information:</b> Name, email, phone, company, and message when you fill out our contact form.</li>
          <li><b>Usage Data:</b> Basic analytics about how you use our website (no personal tracking).</li>
        </ul>
        <h2 style={{ marginTop: 24, fontSize: '1.3rem' }}>How We Use Your Information</h2>
        <ul style={{ marginLeft: 24 }}>
          <li>To respond to your inquiries and provide support.</li>
          <li>To improve our services and website.</li>
          <li>To comply with legal obligations.</li>
        </ul>
        <h2 style={{ marginTop: 24, fontSize: '1.3rem' }}>How We Protect Your Data</h2>
        <ul style={{ marginLeft: 24 }}>
          <li>We do not sell or share your personal information with third parties except as required by law or to provide our services.</li>
          <li>We use secure methods to store and transmit your data.</li>
        </ul>
        <h2 style={{ marginTop: 24, fontSize: '1.3rem' }}>Your Rights</h2>
        <ul style={{ marginLeft: 24 }}>
          <li>You may request to access, update, or delete your information at any time by contacting us.</li>
        </ul>
        <p style={{ marginTop: 24 }}>By using our website or submitting your information, you agree to this privacy policy.</p>
        <p style={{ marginTop: 24, fontSize: '0.95em', color: '#b6c3e0' }}>For questions, contact <a href="mailto:info@visyntech.co.zw" style={{ color: '#6366f1' }}>info@visyntech.co.zw</a> or <a href="mailto:info@irod.co.zw" style={{ color: '#6366f1' }}>info@irod.co.zw</a>.</p>
      </div>
      <Footer />
    </React.Fragment>
  );
}
